<template>
    <div>
      <v-row>
        <v-col>{{ $tc("memberRegistration.step5_extra_items.content.description") }}</v-col>
      </v-row>
      <v-row class="mb-4">
        <v-col>
          <v-card class="pa-4" v-for="itemExtra in registrationObj.extraItems" :key="itemExtra.id">
              <v-card-title class="bg-teal-lighten-5">{{ itemExtra.sectionName }}</v-card-title>

              <v-radio-group v-model="selectedRadios[itemExtra.id]" dense>
                  <v-data-table
                      :headers="headers"
                      :items="itemExtra.items"
                      class="elevation-1"
                      hide-default-footer
                      :footer-props="{
                        'items-per-page-text': $t('dataTable.rowsPerPageText'),
                        'items-per-page-all-text': $t('dataTable.rowsPerPageAllText')
                      }"
                      :no-data-text="$t('dataTable.noDataText')"
                      :headerProps="{
                        'sort-by-text': $t('dataTable.sortByText')
                      }"
                  >
                      <template v-slot:[`item.selected`]="{ item }">
                          <template v-if="item.optType === 'radio'">                            
                            <v-radio :label="item.optLabel" @change="updateCheck($event, item.id)" :value="item.id"></v-radio>
                          </template>
                          <template v-else>
                              <v-checkbox
                                  v-model="item.selected"
                                  @change="updateCheck($event, item.id)"
                                ></v-checkbox>
                          </template>
                      </template>
                      <template v-slot:[`item.optLabel`]="{ item }">
                          <span>{{ item.optLabel }}</span>
                      </template>
                      <template v-slot:[`item.optCost`]="{ item }">
                          <span>${{ item.optCost.toFixed(2) }}</span>
                      </template>
                  </v-data-table>
              </v-radio-group>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="6" sm="6" cols="6" class="text-left">
          <v-btn :color="`${buttonColor}`" class="btn_next" @click="setStep(prevStep)">{{
            $tc("registerEvent.prev")
          }}</v-btn>
        </v-col>
        <v-col md="6" sm="6" cols="6" class="text-right">
          <v-btn :color="`${buttonColor}`" class="btn_next" @click="setStep(nextStep)">{{
            $tc("registerEvent.next")
          }}</v-btn>
        </v-col>
      </v-row>
    </div>
  </template>
  
  <script>
  import { VRow, VCol, VBtn, VCard, VCardTitle, VDataTable, VCheckbox, VRadio, VRadioGroup } from "vuetify/lib";
  import LocalStorageService from "@/services/LocalStorageService";
  export default {
    components: {
      VRow,
      VCol,
      VBtn,
      VCard,
      VCardTitle,
      VDataTable,
      VCheckbox,
      VRadio,
      VRadioGroup
    },
    props: {
      step: Number,
      buttonColor: String,
      extraItems: Array,
      registrationObj: Object,
      previousStep: Number
    },
    data() {
      return {
        feedback: "",
            headers: [
            { text: this.$tc("memberRegistration.step5_extra_items.content.select_title"), value: "selected", sortable: false },
            { text: this.$tc("memberRegistration.step5_extra_items.content.description_title"), value: "optLabel" },
            { text: this.$tc("memberRegistration.step5_extra_items.content.price_title"), value: "optCost" }
        ],
        selected: [],
        selectedRadios: {},
        selectedCheckboxes: {}
      };
    },
    computed: 
    {
        prevStep()
        {
          return this.previousStep;
        },
        nextStep()
        {
          // After Extra Items (step 5) → Feedback (step 6)
          return 6;
        }
    },
    watch: {
      feedback(val) {
        this.$emit("updateFeedback", val);
      },
      registrationObj: {
        handler(newVal) {
          this.registrationObj = newVal
        },
        deep: true
      }
    },
    methods: {
      setStep(step) {
        LocalStorageService.setItem("member_reg", this.registrationObj);
        this.$emit("nextStep", step);
      },
      updateCheck(checked, itemId) {
        this.registrationObj.extraItems.forEach(section => {
            const selectedItem = section.items.find(item => item.id === itemId);
            
            if (selectedItem?.optType === 'radio') {
                section.items.forEach(item => {
                    if (item.optType === 'radio') {
                        item.selected = false;
                    }
                });
            }

            section.items.forEach(item => {
                if (item.id === itemId) {
                    item.selected = selectedItem.optType === 'radio' ? true : checked;
                }
            });
        });
      }
    }
  };
  </script>
  
<style>
.v-data-table {
  background: white;
}
</style>
  